import { defineStore } from 'pinia';
import { useStoreUser } from '@src/store/modules/user';
import { useStoreLoginModal } from '@src/store/modules/loginModal';
import * as api from '@src/api/auth';

export const useStoreWechat = defineStore('Wechat', () => {
    const storeUser = useStoreUser();

    let pollTimer: number | ReturnType<typeof setTimeout> | null = null;
    let expiredTimer: number | ReturnType<typeof setTimeout> | null = null;
    const uuid = ref('');
    const imageBase = ref(''); // 二维码图片
    const isExpired = ref(false); // 是否已超时
    const isBindPhone = ref(true); // 是否已绑定手机号

    const getWechatQrcode = async () => {
        // 重新获取二维码、参数重置
        stopScanPolling();
        uuid.value = '';
        imageBase.value = '';
        isExpired.value = false;
        isBindPhone.value = true;

        const { data } = await api.wechatQrcode({
            code: window.location.href,
            platform: 'PC',
        });
        uuid.value = data.uuid;
        imageBase.value = data.imageBase;

        setPollTimer();
        setExpiredTimer();
    };

    const stopScanPolling = () => {
        clearPollTimer();
        clearExpiredTimer();
    };

    const getScanResult = async () => {
        const res = await api.getScanResult(uuid.value);
        const { token, status } = res as any;
        if (status === 0) {
            setPollTimer();
        } else if (status === 1) {
            // 扫码成功、已绑定手机号
            stopScanPolling();
            await useStoreLoginModal().handleLoginSuccess(token);
        } else if (status === 2) {
            // 扫码成功、未绑定手机号
            stopScanPolling();
            storeUser.setAuth({ token });
            isBindPhone.value = false;
        }
    };

    // 轮询获取微信登录状态
    const setPollTimer = () => {
        clearPollTimer();
        pollTimer = setTimeout(async () => {
            getScanResult();
        }, 1000 * 3);
    };
    const clearPollTimer = () => {
        if (pollTimer) clearTimeout(pollTimer);
        pollTimer = null;
    };

    // 设置超时状态
    const setExpiredTimer = () => {
        expiredTimer = setTimeout(
            () => {
                stopScanPolling();
                isExpired.value = true;
            },
            1000 * 60 * 4
        );
    };
    const clearExpiredTimer = () => {
        if (expiredTimer) clearTimeout(expiredTimer);
        expiredTimer = null;
    };

    return {
        uuid,
        imageBase,
        isExpired,
        isBindPhone,
        getWechatQrcode,
        clearPollTimer,
        clearExpiredTimer,
    };
});
